<script setup lang="ts">
import { computed } from 'vue';
import { TEXT_MAX_LENGTH } from '../types';

const props = defineProps<{
  placeholder?: string;
  maxlength?: number;
  // Champ obligatoire resté vide : bordure rouge.
  invalid?: boolean;
}>();
const message = defineModel<string>({ required: true });

const limit = computed(() => props.maxlength ?? TEXT_MAX_LENGTH);
</script>

<template>
  <label class="block py-[7px]">
    <span class="sr-only">Message au client</span>
    <textarea
      v-model="message"
      rows="3"
      :maxlength="limit"
      :placeholder="placeholder ?? 'Visible sur sa page de commande'"
      :aria-invalid="invalid"
      class="bg-creux text-encre placeholder:text-encre-douce min-h-16 w-full resize-none rounded-[12px] border p-3 text-[14px] leading-[20px]"
      :class="invalid ? 'border-alerte' : 'border-filet'"
    ></textarea>
    <span
      class="text-encre-douce mt-1 block text-right text-[12px] leading-[14px]"
      :class="message.length >= limit && 'text-alerte-texte'"
      aria-live="polite"
    >
      {{ message.length }} / {{ limit }}
    </span>
  </label>
</template>
